import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TicketViewComponent } from './ticket-view/ticket-view.component';
import { TICKETS_PATHS } from './tickets';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: TICKETS_PATHS.ticket,
    component: TicketViewComponent,
    canActivate: [AuthGuard],
    data: { animation: 'TicketsPage', permission: 'ticket.get' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TicketsRoutingModule {}
